import _ from 'lodash';

import { adminClient as apolloClient } from '@/store/apollo';

import AdministratorsGql from '@/store/graphql/system/queries/Administrators.gql';

// import AdministratorGql from '@/store/graphql/system/queries/Administrator.gql';
// import AdministratorsPaginatedGql from '@/store/graphql/system/queries/AdministratorsPaginated.gql';
// import OwnersPaginatedGql from '@/store/graphql/system/queries/OwnersPaginated.gql';
// import TeamMembersPaginatedGql from '@/store/graphql/system/queries/TeamMembersPaginated.gql';
// import CreateAdministratorGql from '@/store/graphql/system/mutations/CreateAdministrator.gql';
// import UpdateAdministratorGql from '@/store/graphql/system/mutations/UpdateAdministrator.gql';
// import DeleteAdministratorGql from '@/store/graphql/system/mutations/DeleteAdministrator.gql';

export default {
    // Administratoren (Team-Zugaenge) eines Webauftritts
    fetchAdministrators: (cmsID = null) =>
        new Promise((resolve, reject) => {
            let variables = {};
            if (cmsID) variables.cms = parseInt(cmsID);

            apolloClient
                .query({
                    query: AdministratorsGql,
                    variables
                })
                .then(({ data }) => resolve(data.Administrators))
                .catch(err => reject(err));
        }),
    // fetchAdministratorsPaginated: data =>
    //     new Promise((resolve, reject) => {
    //         let filters = [];
    //         _.each(data.filters, entry => filters.push(entry));

    //         apolloClient
    //             .query({
    //                 query: AdministratorsPaginatedGql,
    //                 variables: {
    //                     currentPage: _.get(data, 'pageInfo.currentPage', 1),
    //                     perPage: _.get(data, 'pageInfo.perPage', 25),
    //                     order: _.get(data, 'variables.order', 'id'),
    //                     direction: _.get(data, 'variables.direction', 'asc'),
    //                     config: 'base.pagination.account',
    //                     link: '/system/account/',
    //                     filters
    //                 }
    //             })
    //             .then(({ data }) => resolve(data.AdministratorsPaginated))
    //             .catch(err => reject(err));
    //     }),
    // fetchOwnersPaginated: data =>
    //     new Promise((resolve, reject) => {
    //         let filters = [];
    //         _.each(data.filters, entry => filters.push(entry));

    //         apolloClient
    //             .query({
    //                 query: OwnersPaginatedGql,
    //                 variables: {
    //                     currentPage: _.get(data, 'pageInfo.currentPage', 1),
    //                     perPage: _.get(data, 'pageInfo.perPage', 25),
    //                     order: _.get(data, 'variables.order', 'id'),
    //                     direction: _.get(data, 'variables.direction', 'asc'),
    //                     config: 'base.pagination.account',
    //                     link: '/system/account/',
    //                     filters
    //                 }
    //             })
    //             .then(({ data }) => resolve(data.OwnersPaginated))
    //             .catch(err => reject(err));
    //     }),
    // fetchTeamMembersPaginated: data =>
    //     new Promise((resolve, reject) => {
    //         let filters = [];
    //         _.each(data.filters, entry => filters.push(entry));

    //         apolloClient
    //             .query({
    //                 query: TeamMembersPaginatedGql,
    //                 variables: {
    //                     currentPage: _.get(data, 'pageInfo.currentPage', 1),
    //                     perPage: _.get(data, 'pageInfo.perPage', 25),
    //                     order: _.get(data, 'variables.order', 'id'),
    //                     direction: _.get(data, 'variables.direction', 'asc'),
    //                     config: 'base.pagination.team',
    //                     link: '/system/team/',
    //                     filters
    //                 }
    //             })
    //             .then(({ data }) => resolve(data.TeamMembersPaginated))
    //             .catch(err => reject(err));
    //     }),
    // fetchAdministrator: id => {
    //     if (id === undefined) throw new Error('required argument is missing');

    //     return new Promise((resolve, reject) => {
    //         apolloClient
    //             .query({
    //                 query: AdministratorGql,
    //                 variables: { id: parseInt(id) },
    //                 fetchPolicy: 'no-cache'
    //             })
    //             .then(({ data }) => resolve(data.Administrator))
    //             .catch(err => reject(err));
    //     });
    // },
    // create: administrator => {
    //     if (administrator === undefined) throw new Error('required argument is missing');
    //     administrator = _.removeDeepByKey(administrator, '__typename');
    //     return new Promise((resolve, reject) => {
    //         apolloClient
    //             .mutate({
    //                 mutation: CreateAdministratorGql,
    //                 variables: { administrator }
    //             })
    //             .then(({ data }) => {
    //                 apolloClient.clearStore();
    //                 resolve(data.CreateAdministrator);
    //             })
    //             .catch(err => reject(err));
    //     });
    // },
    // update: administrator => {
    //     if (administrator === undefined) throw new Error('required argument is missing');

    //     administrator = _.removeDeepByKey(administrator, '__typename');
    //     return new Promise((resolve, reject) => {
    //         apolloClient
    //             .mutate({
    //                 mutation: UpdateAdministratorGql,
    //                 variables: { administrator }
    //             })
    //             .then(({ data }) => {
    //                 apolloClient.clearStore();
    //                 resolve(data.UpdateAdministrator);
    //             })
    //             .catch(err => reject(err));
    //     });
    // },
    // delete: id => {
    //     if (id === undefined) throw new Error('required argument is missing');

    //     return new Promise((resolve, reject) => {
    //         apolloClient
    //             .mutate({
    //                 mutation: DeleteAdministratorGql,
    //                 variables: { id: parseInt(id) }
    //             })
    //             .then(({ data }) => {
    //                 apolloClient.clearStore();
    //                 resolve(data.CO_DeleteAdministrator);
    //             })
    //             .catch(err => reject(err));
    //     });
    // }
};
